import { Autocomplete } from '@mui/material';
import { FC, useRef, useState } from 'react';

import { ContainerContainerNamesListParams, PieceType, Workflow } from '@apiContract';
import { useGetContainerNamesQuery, useGetContainerTypesQuery } from 'src/redux/api/container';
import DebounceTextField, { DebounceTextFieldHandle } from 'src/uiKit/DebounceTextField';
import { getPieceTypeByWorkflow } from 'src/utils/piece';

type Props = {
  defaultValue?: string | null;
  onChange: (value: string) => void;
  searchParams?: ContainerContainerNamesListParams;
  workflow: Workflow;
  containerTypeId: number;
  onLoading?: (isLoading: boolean) => void;
};

const InputStorageGroupName: FC<Props> = ({ workflow, onLoading, containerTypeId, defaultValue, onChange }) => {
  const [searchValue, setSearchValue] = useState(defaultValue);
  const ref = useRef<DebounceTextFieldHandle>(null);
  const { data: containerTypes = [] } = useGetContainerTypesQuery();

  const { data, isLoading } = useGetContainerNamesQuery(
    {
      'Filter.ContainerNumberContains': searchValue || '',
      'Filter.ContainerTypeId': containerTypeId,
      'Paging.ItemsPerPage': 10,
      'Paging.PageNumber': 0,
    },
  );

  const onChangeValue = (value: string) => {
    setSearchValue(value);
    onChange(value);
  };

  const options =
    (data?.reduce<string[]>((acc, item) => {
        if (item) {
          acc.push(item);
        }
        return acc;
      }, [])) ||
    [];

  const label =
    getPieceTypeByWorkflow(workflow) === PieceType.Package
      ? 'Group Name'
      : containerTypes?.find((type) => type.id === Number(containerTypeId))?.containerUiLabel || '';

  return (
    <Autocomplete
      freeSolo
      filterOptions={(x) => x} // https://mui.com/material-ui/react-autocomplete/#search-as-you-type
      options={options}
      fullWidth
      disablePortal
      defaultValue={defaultValue}
      onInputChange={(_, value) => ref.current?.setValue(value)}
      renderInput={(params) => (
        <DebounceTextField
          {...params}
          isLoading={isLoading}
          onChangeDebounced={onChangeValue}
          onDebounceChange={onLoading}
          label={label}
          defaultValue={defaultValue}
          ref={ref}
        />
      )}
    />
  );
};

export default InputStorageGroupName;
